import { useCopyToClipboard } from "@uidotdev/usehooks";
import { CopyOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import Button, { ButtonProps } from "../button";
import { useNotification } from "@/shared/feedback/notification";

export type CopyButtonProps = Omit<ButtonProps, "onClick" | "value"> & {
  /** Что положить в буфер обмена. */
  value: string;
};

export function CopyButton({ value, children, ...props }: CopyButtonProps) {
  const t = useTranslations("Common");
  const [, copyToClipboard] = useCopyToClipboard();
  const notify = useNotification();

  return (
    <Button
      icon={<CopyOutlined />}
      onClick={() => {
        copyToClipboard(value);

        notify?.success({
          message: t("Copied"),
        });
      }}
      {...props}
    >
      {children ?? t("Copy")}
    </Button>
  );
}
